import "./svgfixer.js";

function BackpackLink({ user, url }) {
  var logged_in = !!user;
  var has_portrait = logged_in && user.portrait_url;
  var portrait = (
    <svg className="hiker">
      <use xlinkHref="#hiker"></use>
    </svg>
  );
  if (logged_in) {
    if (has_portrait) {
      portrait = (
        <a
          href={url + "/backpack"}
          className="avatar"
          style={{ backgroundImage: "url('" + user.portrait_url + "')" }}
        />
      );
    } else {
      portrait = (
        <a href={url + "/backpack"}>
          <svg className="hiker">
            <use xlinkHref="#hiker"></use>
          </svg>
        </a>
      );
    }
  }
  return (
    <span>
      {portrait}
      <h2>
        {logged_in ? (
          <a href={url + "/backpack"}>My Backpack</a>
        ) : (
          "My Backpack"
        )}
      </h2>
      {!logged_in ? <p>Log in (or Sign up)</p> : ""}
    </span>
  );
}

function Nav({ user, nav_data }) {
  var logged_in = !!user;
  var menus = nav_data;
  // if not logged in but menus contain logout, it means we are logged
  // into plone site with no vms token...redirect to login to fix that
  if (!!menus) {
    menus.user.map((item, i) => {
      if (item.title == "Log out" && !logged_in) {
        var url = window.location.href;
        window.location.href = window.cms_base_url + "/login?came_from=" + url;
      }
    });
  }
  return (
    <header>
      <div id="intro-strip">
        <div className="content">
          <h1 id="main-logo">
            <a href={window.cms_base_url}>
              <img
                className="logo"
                src={
                  window.cms_base_url +
                  "/++theme++plonetheme.wta/images/wta-logo.png"
                }
                alt="Washington Trails Association"
              />
            </a>
          </h1>
          <p className="tagline">
            Empowering hikers to build a world where trails connect people and
            places
          </p>
          <nav className="aux-menu">
            <ul className="menu">
              <li className="donate">
                <a href={menus && menus.donate && menus.donate.href}>Donate</a>
              </li>
              <li className="search">
                <svg viewBox="0 0 16 16">
                  <title>Search</title>
                  <use xlinkHref="#search-icon"></use>
                </svg>
                <label htmlFor="search-field">Site Search</label>
                <form action={window.cms_base_url + "/search"}>
                  <input
                    id="search-field"
                    name="SearchableText"
                    type="text"
                    placeholder="&hellip;"
                  />
                  <button>Go</button>
                </form>
              </li>
              <li className="shop">
                <a href="https://shop.wta.org" target="_blank">
                  Shop
                </a>
              </li>
              <li className="news">
                <a href={menus && menus.news && menus.news.href}>News</a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
      <div id="main-strip">
        <div id="menu-back"></div>
        <div className="content">
          <nav className="main-menu">
            <input
              type="checkbox"
              id="show-menu"
              className="show-menu"
              role="button"
            />
            <label htmlFor="show-menu" className="menu-toggle">
              Menu
            </label>
            <label htmlFor="show-menu" className="menu-toggle close">
              Close
            </label>
            <ul className="menu mobile-menu">
              {menus &&
                menus.primary.map((item, i) => {
                  return (
                    <li
                      key={item.href}
                      className={
                        (item.submenu && item.id != "join"
                          ? "has-children"
                          : "") + (i > 3 ? " aux" : "")
                      }
                    >
                      <a href={item.href}>{item.title}</a>
                      {item.submenu && item.id !== "join" ? (
                        <div className="submenu-wrap">
                          <ul className="submenu">
                            {item.submenu.map((item) => (
                              <li key={item.href}>
                                <a href={item.href}>{item.title}</a>
                              </li>
                            ))}
                          </ul>
                        </div>
                      ) : (
                        ""
                      )}
                    </li>
                  );
                })}
              <li className="search aux">
                <svg viewBox="0 0 16 16">
                  <title>Search</title>
                  <use xlinkHref="#search-icon"></use>
                </svg>
                <label htmlFor="mobile-search-field">Site Search</label>
                <form action={window.cms_base_url + "/search"}>
                  <input
                    id="mobile-search-field"
                    name="SearchableText"
                    type="text"
                    placeholder="&hellip;"
                  />
                  <button>Go</button>
                </form>
              </li>
            </ul>
          </nav>

          <nav
            className={
              "account-menu" + (logged_in ? " logged-in" : " logged-out")
            }
          >
            <BackpackLink user={user} url={window.cms_base_url} />
            <ul className="menu">
              {menus &&
                menus.user.map((item, i) => {
                  return (
                    <li key={item.href}>
                      <a
                        href={
                          item.title == "Log out"
                            ? window.base_url + "logout"
                            : item.href
                        }
                      >
                        {item.title}
                      </a>
                    </li>
                  );
                })}
            </ul>
          </nav>
        </div>
      </div>
    </header>
  );
}

export default Nav;
